import {useSelectedSpace} from "@src/features/space-home/hooks/use-selected-space";
import React from "react";
import {Outlet, useNavigate} from "react-router-dom";


export function RequireIsSpaceMemberLayout() {
	const navigate = useNavigate();
	
	// We assume this layout is only used in routes with the spaceId route param, so
	// if selectedSpace is null it means we tried to access a space we don't belong to
	const selectedSpace = useSelectedSpace();
	
	const isSpaceMember = selectedSpace !== null;
	
	React.useEffect(() => {
		if (!isSpaceMember) {
			navigate("/dashboard");
		}
	}, [navigate, isSpaceMember]);
	
	if (!isSpaceMember) {
		return (
			<p>
				You don't have permission to view this Space.
			</p>
		);
	}
	
	return (
		<Outlet/>
	);
}
